"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Bulb = function Bulb(_ref) {
  var size = _ref.size,
      color = _ref.color,
      style = _ref.style;
  return _react["default"].createElement("svg", {
    style: _objectSpread({}, style, {
      width: size * 2,
      height: size * 2
    })
  }, _react["default"].createElement("defs", null, _react["default"].createElement("radialGradient", {
    id: "grad1",
    cx: "0%",
    cy: "0%",
    r: "100%",
    fx: "30%",
    fy: "30%"
  }, _react["default"].createElement("stop", {
    offset: "0%",
    style: {
      stopColor: 'white',
      stopOpacity: 0.4
    }
  }), _react["default"].createElement("stop", {
    offset: "90%",
    style: {
      stopColor: color,
      stopOpacity: 0
    }
  })), _react["default"].createElement("radialGradient", {
    id: "grad2",
    cx: "150%",
    cy: "150%",
    r: "200%",
    fx: "100%",
    fy: "100%"
  }, _react["default"].createElement("stop", {
    offset: "0%",
    style: {
      stopColor: 'black',
      stopOpacity: 0.45
    }
  }), _react["default"].createElement("stop", {
    offset: "100%",
    style: {
      stopColor: color,
      stopOpacity: 0.2
    }
  }))), _react["default"].createElement("circle", {
    cx: size,
    cy: size,
    r: size,
    fill: color
  }), _react["default"].createElement("circle", {
    cx: size,
    cy: size,
    r: size,
    fill: "url(#grad1)"
  }), _react["default"].createElement("circle", {
    cx: size,
    cy: size,
    r: size,
    fill: "url(#grad2)"
  }));
};

Bulb.propTypes = {
  style: _propTypes["default"].shape({}),
  size: _propTypes["default"].number,
  color: _propTypes["default"].string
};
Bulb.defaultProps = {
  style: Object.freeze({}),
  size: 40,
  color: 'red'
};
var _default = Bulb;
exports["default"] = _default;
